
export const GET_TASK_PROJECT = "GET_TASK_PROJECT"
export const ADD_NEW_PROJECT  ="ADD_NEW_PROJECT "

export const Delete_PROJECT  ="Delete_PROJECT "

export const EDIT_PROJECT  ="EDIT_PROJECT"